<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.dkzj">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">多辊轧机</span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">我公司提供的多辊轧机有以下的特点：</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>1
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#333333;"
        >工作辊整个辊身以支承辊作媒介支承在牌坊上，轧辊宽度方向承受的弯曲很小，从而能够使用小直径的工作辊。</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>2
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#333333;"
        >由于轧机的刚度提高，并使用了高硬度轧辊，因而能生产出高精度的产品，其精度与四辊机相比可提高四倍。</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>3
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">新型的二十辊机可将</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">2.75mm</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">的原料一个轧程轧到</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">0.18</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">～</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">0.23</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">，</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">3.0mm</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">的原料一个轧程轧到</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">0.2</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">～</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">0.25</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">，同时对多种合金钢品种均能适应；</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>4
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">工作辊直径减小，可以实现轧薄，普通</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">1250</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">四辊轧机最薄可轧到</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">0.25mm</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">，而用二十辊轧机可以轧到</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">0.08mm</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">。</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>5
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">由于轧辊直径小，导致变形区接触面积减小</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">,</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">从而使总轧制力减小。二十辊轧机的轧制力</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">(</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">在轧制条件相同时</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">)</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">约为四辊轧机的</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">25%</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">，由于轧制力的减小使轧制力矩减小</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">,</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">从而可节约电能</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">30~40%</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">；</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>6
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#333333;"
        >在多辊机上实际强化压下，使轧制道次减少，并有可能减少轧程，从而提高了生产效率和成材率，降低成本。</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>7
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">由于多辊轧机采用大张力轧制，带钢的平直度、板型显著提高。</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>8
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">轧机的体积减小，重量减轻，相对降低了设备投资费用。</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>9
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp; &nbsp;</span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#333333;"
        >多辊轧机常用备件（如轧辊、轴承等）均比四辊机小得多，因此可以大大减低成本；</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        dkzj: require("../../../assets/img/common/dkzj.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/dkzj.vue